import {DataTable} from '@/components/atoms';

const ReviewStoreListTable = () => {
  const columns = [
    {columnKey: 'store_id', header: 'Store Id'},
    {columnKey: 'layer_1_dollar_spend', header: 'Layer 1 Dollar spend'},
    {columnKey: 'layer_1_points_reward', header: 'Layer 1 Points to Reward'},
    {columnKey: 'layer_2_dollar_spend', header: 'Layer 2 Dollar spend'},
    {columnKey: 'layer_2_points_reward', header: 'Layer 2 Points to Reward'},
    {columnKey: 'layer_3_dollar_spend', header: 'Layer 3 Dollar spend'},
    {columnKey: 'layer_3_points_reward', header: 'Layer 3 Points to Reward'},
    {columnKey: 'store_segment', header: 'Store Segment'},
    {columnKey: 'revenue', header: 'Previous year base revenue (Optional)'}
  ];

  const tableData = [
    {
      store_id: '20003310919',
      layer_1_dollar_spend: '2700',
      layer_1_points_reward: '120',
      layer_2_dollar_spend: '4000',
      layer_2_points_reward: '130',
      layer_3_dollar_spend: '2400',
      layer_3_points_reward: '100',
      store_segment: '',
      revenue: ''
    },
    {
      store_id: '20003310920',
      layer_1_dollar_spend: '2700',
      layer_1_points_reward: '120',
      layer_2_dollar_spend: '4000',
      layer_2_points_reward: '130',
      layer_3_dollar_spend: '2400',
      layer_3_points_reward: '100',
      store_segment: '',
      revenue: ''
    },
    {
      store_id: '20003310921',
      layer_1_dollar_spend: '2700',
      layer_1_points_reward: '120',
      layer_2_dollar_spend: '4000',
      layer_2_points_reward: '130',
      layer_3_dollar_spend: '2400',
      layer_3_points_reward: '100',
      store_segment: '',
      revenue: ''
    },
    {
      store_id: '20003310922',
      layer_1_dollar_spend: '2700',
      layer_1_points_reward: '120',
      layer_2_dollar_spend: '4000',
      layer_2_points_reward: '130',
      layer_3_dollar_spend: '2400',
      layer_3_points_reward: '100',
      store_segment: '',
      revenue: ''
    },
    {
      store_id: '20003310923',
      layer_1_dollar_spend: '2700',
      layer_1_points_reward: '120',
      layer_2_dollar_spend: '4000',
      layer_2_points_reward: '130',
      layer_3_dollar_spend: '2400',
      layer_3_points_reward: '100',
      store_segment: '',
      revenue: ''
    },
    {
      store_id: '20003310919',
      layer_1_dollar_spend: '2700',
      layer_1_points_reward: '120',
      layer_2_dollar_spend: '4000',
      layer_2_points_reward: '130',
      layer_3_dollar_spend: '2400',
      layer_3_points_reward: '100',
      store_segment: '',
      revenue: ''
    }
  ];

  return (
    <div className='products-table store-list'>
      <DataTable
        columns={columns}
        data={tableData}
        tableHeader='Uploaded File'
        tableDescription='Product-list-oct-24.csv'
        isDark
      />
    </div>
  );
};

export default ReviewStoreListTable;
